/*
 * random-products.js (toserof) — Ürün listelerini "her ziyarette farklı ürünler" gelecek
 * şekilde rastgeleleştirir. Shopify'da native random sort yok; bu yüzden:
 *   - Koleksiyon/Arama: varsayılan görünümde RASTGELE SAYFA dilimi çekilir (Section Rendering
 *     API) + grid içi Fisher-Yates karıştırılır → koleksiyonun derinindeki ürünler de gelir.
 *   - Ana sayfa "featured" slider: kaynak koleksiyonun rastgele sayfasından N kart çekilir,
 *     slaytlar yeniden kurulur (fetch hata verirse mevcut slaytlar karıştırılır).
 * Kullanıcı sıralama/filtre/sayfa seçtiyse koleksiyon/aramada niyete saygı duyulur (random YOK).
 * Hedef konteyner yoksa modüller sessizce no-op olur. Tek sefer çalışır (guard).
 */
(function () {
  "use strict";
  if (window.__toserofRandomProducts) return;
  window.__toserofRandomProducts = true;

  var internal = false; // kendi DOM değişikliklerimizi MutationObserver'dan gizle

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function directChildren(container, selector) {
    return Array.prototype.filter.call(container.children, function (el) {
      return el.matches && el.matches(selector);
    });
  }

  function shuffleInto(container, items, updateFn) {
    if (!container || items.length < 2) { if (updateFn) updateFn(); return; }
    internal = true;
    var frag = document.createDocumentFragment();
    shuffle(items.slice()).forEach(function (el) { frag.appendChild(el); });
    container.appendChild(frag);
    if (updateFn) updateFn();
    setTimeout(function () { internal = false; }, 0);
  }

  function hasUserOrdering() {
    var p = new URLSearchParams(window.location.search);
    if (p.get("sort_by")) return true;
    var page = p.get("page");
    if (page && page !== "1") return true;
    var filtered = false;
    p.forEach(function (v, k) { if (k.indexOf("filter.") === 0) filtered = true; });
    return filtered;
  }

  /* ---------------- KOLEKSİYON / ARAMA ---------------- */
  function randomizeGrid() {
    var grid = document.getElementById("product-grid");
    var container = document.getElementById("ProductGridContainer");
    if (!grid || !container) { revealGrid(); return; }

    observeContainer(container);

    // random hazır olana dek grid gizliyse aç (flash olmasın). settled: tek-seferlik kilit —
    // safety açtıysa GEÇ gelen random SWAP EDİLMEZ (gecikmiş flash olmaz).
    var settled = false;
    function done() { if (settled) return; settled = true; clearTimeout(safety); revealGrid(); }
    var safety = setTimeout(done, 2500); // fetch çok uzarsa son çare: ne varsa göster (ana grid boş kalmasın)

    if (hasUserOrdering()) { done(); return; } // kullanıcı niyeti — dokunma (grid zaten gizlenmedi)

    var count = parseInt(grid.getAttribute("data-products-count") || "0", 10);
    var per = parseInt(grid.getAttribute("data-per-page") || "0", 10);
    var sectionId = grid.getAttribute("data-id");
    var totalPages = (count > 0 && per > 0) ? Math.ceil(count / per) : 1;

    function shuffleCurrent() {
      var g = document.getElementById("product-grid");
      if (g) shuffleInto(g, directChildren(g, ".collection__grid__item"));
    }

    if (totalPages <= 1 || !sectionId) { shuffleCurrent(); done(); return; }

    var R = 1 + Math.floor(Math.random() * totalPages);
    if (R === 1) { shuffleCurrent(); done(); return; }

    var qs = new URLSearchParams(window.location.search);
    qs.set("section_id", sectionId);
    qs.set("page", String(R));

    fetch(window.location.pathname + "?" + qs.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
      .then(function (html) {
        if (settled) return; // safety zaten 1.sayfayı açtı → geç random'ı swap etme (flash olmaz)
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newC = doc.getElementById("ProductGridContainer");
        if (!newC) throw "no-container";
        internal = true;
        container.innerHTML = newC.innerHTML;
        setTimeout(function () { internal = false; }, 0);
        shuffleCurrent();
        done();
      })
      .catch(function () { if (!settled) { shuffleCurrent(); done(); } });
  }

  function revealGrid() { document.documentElement.classList.remove("toserof-grid-pending"); }

  // facets.js filtre/sıralama sonrası #ProductGridContainer'ı değiştirir → varsayılan görünümde
  // grid'i tekrar karıştır (re-fetch etmeyiz; kullanıcı seçtiyse niyete saygı).
  function observeContainer(container) {
    if (container.__toserofObserved) return;
    container.__toserofObserved = true;
    var obs = new MutationObserver(function () {
      if (internal) return;
      if (hasUserOrdering()) return;
      var g = document.getElementById("product-grid");
      if (g) shuffleInto(g, directChildren(g, ".collection__grid__item"));
    });
    obs.observe(container, { childList: true });
  }

  /* ---------------- ANA SAYFA FEATURED SLIDER ---------------- */
  function randomizeFeatured() {
    var roots = document.querySelectorAll("[data-random-featured]");
    Array.prototype.forEach.call(roots, function (root) {
      var cont = root.querySelector("[data-swiper-container]");
      if (!cont) return;
      var slides = directChildren(cont, "[data-swiper-slide]");
      if (!slides.length) return;
      var slideshow = root.querySelector("slideshow-section") || root.closest("slideshow-section");
      var handle = (root.getAttribute("data-source-collection") || "").trim();
      var want = slides.length;

      function swiperUpdate() {
        var sw = slideshow && slideshow.swiper;
        if (!sw) return;
        try {
          if (sw.params && sw.params.loop && sw.loopDestroy && sw.loopCreate) { sw.loopDestroy(); sw.loopCreate(); }
          sw.update();
          sw.slideTo(0, 0, false);
        } catch (e) {}
      }
      // done: tek seferlik kilit. Önce hangisi biterse (random build / safety) o kazanır;
      // safety açtıysa GEÇ gelen random SWAP EDİLMEZ → varsayılan kalır, gecikmiş flash OLMAZ.
      var done = false;
      function reveal() { root.classList.add("random-ready"); }
      function finish(buildFn) {
        if (done) return;
        done = true;
        clearTimeout(safety);
        internal = true;
        if (buildFn) { try { buildFn(); } catch (e) {} }
        reveal();
        setTimeout(function () { internal = false; }, 0);
      }
      function doShuffle() { shuffleInto(cont, slides, swiperUpdate); }

      // 5sn'de random hâlâ gelmediyse son çare: varsayılanı göster (artık random swap etmez)
      var safety = setTimeout(function () { finish(null); }, 5000);

      if (!handle) { finish(doShuffle); return; }

      var col = "/collections/" + encodeURIComponent(handle);
      fetchGrid(col + "?page=1")
        .then(function (g1) {
          var count = parseInt(g1.getAttribute("data-products-count") || "0", 10);
          var per = parseInt(g1.getAttribute("data-per-page") || "0", 10) || 1;
          var pages = count > 0 ? Math.ceil(count / per) : 1;
          if (pages <= 1) return g1;
          var R = 1 + Math.floor(Math.random() * pages);
          return R === 1 ? g1 : fetchGrid(col + "?page=" + R);
        })
        .then(function (grid) {
          var cards = directChildren(grid, ".collection__grid__item");
          if (!cards.length) { finish(doShuffle); return; }
          finish(function () { buildSlides(cards); });
        })
        .catch(function () { finish(doShuffle); });

      function buildSlides(cards) {
        shuffle(cards);
        var picked = cards.slice(0, want);
        slides.forEach(function (s) { s.remove(); });
        picked.forEach(function (card) {
          var slide = document.createElement("div");
          slide.setAttribute("data-swiper-slide", "");
          slide.className = "swiper-slide";
          var inner = document.createElement("div");
          inner.setAttribute("data-cascade", "");
          inner.innerHTML = card.innerHTML; // color-swatch kartı (custom element otomatik upgrade)
          slide.appendChild(inner);
          cont.appendChild(slide);
        });
        swiperUpdate();
      }
    });
  }

  function fetchGrid(url) {
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
      .then(function (html) {
        var g = new DOMParser().parseFromString(html, "text/html").getElementById("product-grid");
        if (!g) throw "no-grid";
        return g;
      });
  }

  function init() {
    try { randomizeGrid(); } catch (e) {}
    try { randomizeFeatured(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
